import script from "./ExamResultWeb.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResultWeb.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResultWeb.vue?vue&type=style&index=0&id=4f0fc504&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f0fc504"]])

export default __exports__